import type { PartCategory } from "./types";

/**
 * Placeholder icons (emoji) until illustrated button art is ready.
 * Swap `asset` paths in when SVG/PNG icons are drawn.
 */
export type UiIconId =
  | "home"
  | "back"
  | "build"
  | "play"
  | "shop"
  | "profile"
  | "fly"
  | "clear"
  | "random"
  | "skip"
  | "hangar"
  | "sound-on"
  | "sound-off"
  | "stars"
  | "earn"
  | "buy"
  | "owned"
  | "reset"
  | "cancel"
  | "confirm"
  | "easy"
  | "medium"
  | "hard"
  | "count-stars"
  | "planet-jump"
  | "spelling"
  | "constellation"
  | "space-puzzle"
  | "asteroid-sum"
  | "left"
  | "right"
  | "preview"
  | "retry"
  | "menu"
  | "category-nose"
  | "category-fuselage"
  | "category-engine"
  | "category-fin"
  | "category-booster"
  | "category-window";

export interface UiIconDef {
  emoji: string;
  label: string;
  asset?: string;
}

export const UI_ICONS: Record<UiIconId, UiIconDef> = {
  home: { emoji: "🏠", label: "Home" },
  back: { emoji: "◀️", label: "Back" },
  build: { emoji: "🚀", label: "Build" },
  play: { emoji: "🎮", label: "Play" },
  shop: { emoji: "🛒", label: "Star Shop" },
  profile: { emoji: "👨‍🚀", label: "My Progress" },
  fly: { emoji: "🛸", label: "Fly" },
  clear: { emoji: "🧹", label: "Clear rocket" },
  random: { emoji: "🎲", label: "Random rocket" },
  skip: { emoji: "⏭️", label: "Skip facts" },
  hangar: { emoji: "🔧", label: "Hangar" },
  "sound-on": { emoji: "🔊", label: "Sound on" },
  "sound-off": { emoji: "🔇", label: "Sound off" },
  stars: { emoji: "⭐", label: "Stars" },
  earn: { emoji: "🎯", label: "Earn stars" },
  buy: { emoji: "💫", label: "Buy part" },
  owned: { emoji: "✅", label: "Owned" },
  reset: { emoji: "🔄", label: "Reset progress" },
  cancel: { emoji: "✖️", label: "Cancel" },
  confirm: { emoji: "✔️", label: "Confirm" },
  easy: { emoji: "🌱", label: "Easy" },
  medium: { emoji: "🌟", label: "Medium" },
  hard: { emoji: "🔥", label: "Hard" },
  "count-stars": { emoji: "⭐", label: "Count the Stars" },
  "planet-jump": { emoji: "🪐", label: "Planet Jumps" },
  spelling: { emoji: "🔤", label: "Space Words" },
  constellation: { emoji: "✨", label: "Constellation Trace" },
  "space-puzzle": { emoji: "🧩", label: "Space Puzzle" },
  "asteroid-sum": { emoji: "☄️", label: "Asteroid Sum" },
  left: { emoji: "⬅️", label: "Move left" },
  right: { emoji: "➡️", label: "Move right" },
  preview: { emoji: "👁️", label: "Hold to peek at solution" },
  retry: { emoji: "🔁", label: "Play again" },
  menu: { emoji: "📋", label: "Activity menu" },
  "category-nose": { emoji: "🔺", label: "Nose cones" },
  "category-fuselage": { emoji: "🛢️", label: "Bodies" },
  "category-engine": { emoji: "🔥", label: "Engines" },
  "category-fin": { emoji: "🪁", label: "Fins" },
  "category-booster": { emoji: "⚡", label: "Boosters" },
  "category-window": { emoji: "🔭", label: "Windows" },
};

const CATEGORY_ICON_IDS: Record<PartCategory, UiIconId> = {
  nose: "category-nose",
  fuselage: "category-fuselage",
  engine: "category-engine",
  fin: "category-fin",
  booster: "category-booster",
  window: "category-window",
};

export function categoryIconId(category: PartCategory): UiIconId {
  return CATEGORY_ICON_IDS[category];
}

export const ACTIVITY_ICON_IDS: Record<string, UiIconId> = {
  "count-stars": "count-stars",
  "planet-jump": "planet-jump",
  spelling: "spelling",
  constellation: "constellation",
  "space-puzzle": "space-puzzle",
  "asteroid-sum": "asteroid-sum",
};
